import React from 'react';
import styles from '../../styles/HomeAdvantages.module.scss';

const ADVANTAGES = [
  {
    id: 'search',
    title: 'Зручний пошук',
    text: 'Розумний пошук потрібних товарів за каталогами виробників з урахуванням марки та моделі авто. Допомагаємо з підбором запчастин.',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="22" cy="22" r="12" stroke="currentColor" strokeWidth="2.5" />
        <path d="M31 31l9 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'control',
    title: 'Контроль етапів',
    text: 'Контролюємо роботу на кожному етапі: від замовлення на сайті до відвантаження зі складу та доставки. Дотримуємось термінів і якості сервісу.',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="10" y="8" width="28" height="32" rx="3" stroke="currentColor" strokeWidth="2.5" />
        <path d="M16 18h16M16 24h16M16 30h10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'quality',
    title: 'Якість запчастин',
    text: 'У наявності лише перевірені деталі від надійних виробників. Усі запчастини проходять контроль якості, мають гарантію та забезпечують довговічну роботу.',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="24" cy="24" r="14" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="24" cy="24" r="6" stroke="currentColor" strokeWidth="2.5" />
        <path d="M24 10v4M24 34v4M10 24h4M34 24h4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'feedback',
    title: 'Зворотний зв\'язок',
    text: 'Оперативна технічна підтримка та професійна консультація під час оформлення замовлення.',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <path
          d="M10 12a4 4 0 014-4h20a4 4 0 014 4v14a4 4 0 01-4 4H22l-8 8v-8h-4a4 4 0 01-4-4V12z"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <circle cx="18" cy="21" r="1.5" fill="currentColor" />
        <circle cx="24" cy="21" r="1.5" fill="currentColor" />
        <circle cx="30" cy="21" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
];

const ShopAdvantages = () => (
  <section className={`${styles.section} homeFullBleed`}>
    <h2 className={styles.title}>Наші переваги</h2>
    <div className={styles.grid}>
      {ADVANTAGES.map(({ id, title, text, icon }) => (
        <article key={id} className={styles.card}>
          <div className={styles.icon}>{icon}</div>
          <h3 className={styles.cardTitle}>{title}</h3>
          <p className={styles.cardText}>{text}</p>
        </article>
      ))}
    </div>
  </section>
);

export default ShopAdvantages;
